define('viewmodels/pages/cash/deposit/playOkLimitsReached',['underscore', 'knockout'], function (_, ko) {

    var PlayOkLimitsReached = function (getCmsField, player, usableMethod) {
        var self = this;

        self.currentDepositLimitInfo = ko.pureComputed(function() {
            return player.payments.currentDepositLimitInfo();
        });

        self.title = getCmsField('play_ok_limits_reached_title');
        self.image = getCmsField('play_ok_image');

        self.message = ko.pureComputed(function() {
            if (!self.currentDepositLimitInfo()) {
                return '';
            }

            var fieldName = self.currentDepositLimitInfo().period().toLowerCase() +
                (self.currentDepositLimitInfo().isSpendingBudget() ? '_spending_budget_' : '_deposit_limit_') +
                (self.currentDepositLimitInfo().availableToDeposit() > 0 ? 'minimum_deposit_message' : 'reached_message');

            return getCmsField(fieldName)();
        }).replacements({
            limit: self.currentDepositLimitInfo.property('limit').property('amount'),
            availableToDeposit: self.currentDepositLimitInfo.property('availableToDeposit'),
            minimumDeposit: usableMethod.property('minToDeposit').withFallback(10),
            nextDepositDate: self.currentDepositLimitInfo.pipe(_.skipFalsy(function(currentDepositLimitInfo) {
                return currentDepositLimitInfo.nextDepositDate.formatMoment('MMMM Do YYYY');
            })).unwrapped()
        });
    };

    return PlayOkLimitsReached;
});

